export default __webpack_public_path__ + "static/media/b1.e02130e9.png";